/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindOneQueryResponse, FilesControllerFindOnePathParams, FilesControllerFindOneQueryParams, FilesControllerFindOne400, FilesControllerFindOne401, FilesControllerFindOne403, FilesControllerFindOne404 } from "../../models/filesController/FilesControllerFindOne";

function getFilesControllerFindOneUrl(id: FilesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}` as const }  
  return res
}

/**
 * @description Returns File object from the database.
 * @summary Get file by ID
 * {@link /api/v1/files/:id}
 */
export async function filesControllerFindOne(id: FilesControllerFindOnePathParams["id"], params?: FilesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerFindOneQueryResponse, ResponseErrorConfig<FilesControllerFindOne400 | FilesControllerFindOne401 | FilesControllerFindOne403 | FilesControllerFindOne404>, unknown>({ method : "GET", url : getFilesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}